module.exports = __webpack_public_path__ + "static/media/PersonalIcon.e6170232.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Infos/PersonalIcon.jpg
// module id = 672
// module chunks = 0